import Cookies from 'js-cookie'
import Vue from 'vue'
import i18n from '@/locales'
import { Locale } from '@/locales'
import VueRouter, { RouteConfig } from 'vue-router'

Vue.use(VueRouter)

const getBrowserLanguage = (window: any): string => {
  const savedLanguange = Cookies.get('lang')
  if (savedLanguange) {
    return savedLanguange;
  }
  const language =
    (window.navigator.languages && window.navigator.languages[0]) ||
    window.navigator.language ||
    window.navigator.userLanguage ||
    window.navigator.browserLanguage
  
  if (language === 'zh-TW') {
    return 'zh-hant';
  }
  return language.substr(0, 2)
}

const selectLocale = (locale: string): Locale => {
  if (locale) {
    locale = locale.toLowerCase();
  }
  switch (locale) {
    case 'ja':
      return Locale.JA
    case 'jp':
      return Locale.JA
    case 'kr':
      return Locale.KO
    case 'ko':
      return Locale.KO
    case 'zh':
      return Locale.ZH
    case 'zh-hans':
      return Locale.ZH
    case 'zh-hant':
      return Locale["ZH-HANT"]
    default:
      return Locale.EN
  }
}

const routes: Array<RouteConfig> = [
  {
    path: '/email_verify/:verifyToken',
    redirect: to => `${selectLocale(getBrowserLanguage(window))}${to.path}`
  },
  {
    path: '/forgot/:verifyToken',
    redirect: to => `${selectLocale(getBrowserLanguage(window))}${to.path}`
  },
  {
    path: '/checkout/alipay_confirm/:itemId',
    redirect: to => `${selectLocale(getBrowserLanguage(window))}${to.path}`
  },
  {
    path: '/checkout/stripe_confirm/:itemId/:requestId',
    redirect: to => `${selectLocale(getBrowserLanguage(window))}${to.path}`
  },
  {
    path: '/account/purchase',
    redirect: to => `${selectLocale(getBrowserLanguage(window))}${to.path}`
  },
  {
    path: '/confirm_delete/:verifyToken',
    redirect: to => `${selectLocale(getBrowserLanguage(window))}${to.path}`
  },
  {
    path: '/:lang',
    component: {
      render (c) { return c('router-view') }
    },
    children: [
      {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home.vue'),
        meta: {
          needsLoggedIn: false,
        },
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/Login.vue'),
        meta: {
          needsLoggedIn: false,
        },
      },
      {
        path: 'forgot/:verifyToken',
        name: 'ChangePassword',
        component: () => import('@/views/ChangePassword.vue'),
        meta: {
          needsLoggedIn: false,
        },
      },
      {
        path: 'forgot',
        name: 'ForgotPassword',
        component: () => import('@/views/ForgotPassword.vue'),
        meta: {
          needsLoggedIn: false,
        },
      },
      {
        path: 'switch',
        name: 'NintendoSwitchPage',
        component: () => import('@/views/pages/switch/NintendoSwitchPage.vue'),
        meta: {
          needsLoggedIn: false,
        },
      },
      {
        path: 'song_ranking/:type?',
        name: 'SongRanking',
        component: () => import('@/views/SongRanking.vue'),
        meta: {
          needsLoggedIn: false,
        },
      },
      {
        path: 'terms_of_service',
        name: 'TermsOfService',
        component: () => import('@/views/TermsOfService.vue'),
        meta: {
          needsLoggedIn: false,
        },
      },
      {
        path: 'derivative_policy',
        name: 'DerivativePolicy',
        component: () => import('@/views/DerivativePolicy.vue'),
        meta: {
          needsLoggedIn: false,
        },
      },
      {
        path: 'privacy_policy',
        name: 'PrivacyPolicy',
        component: () => import('@/views/PrivacyPolicy.vue'),
        meta: {
          needsLoggedIn: false,
        },
      },
      {
        path: 'streaming_guidelines',
        name: 'StreamingGuidelines',
        component: () => import('@/views/StreamingGuidelines.vue'),
        meta: {
          needsLoggedIn: false,
        },
      },
      {
        path: 'goods',
        name: 'Goods',
        component: () => import('@/views/Goods.vue'),
        meta: {
          needsLoggedIn: false,
        },
      },
      {
        path: 'story',
        name: 'Story',
        component: () => import('@/views/Story.vue'),
        meta: {
          needsLoggedIn: false,
        },
      },
      {
        path: 'email_verify/:verifyToken',
        name: 'ChangeEmailVerify',
        component: () => import('@/views/ChangeEmail.vue')
      },
      {
        path: 'checkout/alipay_confirm/:itemId',
        name: 'PurchaseConfirmAlipay',
        component: () => import('@/views/PurchaseComplete.vue')
      },
      {
        path: 'checkout/wechat_confirm/:itemId',
        name: 'PurchaseConfirmWechat',
        component: () => import('@/views/PurchaseComplete.vue')
      },
      {
        path: 'checkout/stripe_confirm/:itemId/:requestId',
        name: 'PurchaseConfirmStripe',
        component: () => import('@/views/PurchaseComplete.vue')
      },
      {
        path: 'confirm_delete/:verifyToken',
        name: 'DeleteUserConfirm',
        component: () => import('@/views/ConfirmDeleteUser.vue'),
      },
      {
        path: 'maintenance',
        name: 'Maintenance',
        redirect: { name: 'Account' },
        meta: {
          needsLoggedIn: false,
        },
      },
      {
        path: 'account',
        component: () => import('@/views/pages/account/AccountContainer.vue'),
        meta: {
          needsLoggedIn: true,
        },
        children: [
          {
            path: '/',
            name: 'Account',
            component: () => import('@/views/Account.vue'),
          },
          // {
          //   path: 'purchase',
          //   name: 'Purchase',
          //   component: () => import('@/views/PurchaseMemories.vue')
          // },
          {
            path: 'purchase',
            name: 'purchase',
            component: () => import('@/views/GlobalPurchaseMemories.vue')
          },
          {
            path: 'purchase',
            name: 'GlobalPurchase',
            component: () => import('@/views/GlobalPurchaseMemories.vue')
          },
          {
            path: 'change_username',
            name: 'ChangeUsername',
            component: () => import('@/views/ChangeUsername.vue')
          },
          {
            path: 'change_email',
            name: 'ChangeEmail',
            component: () => import('@/views/ChangeEmail.vue')
          },
          {
            path: 'select_region',
            name: 'SelectRegion',
            component: () => import('@/views/SelectRegion.vue')
          },
        ]
      },
      { path: "*", redirect: (to) => `/${selectLocale(getBrowserLanguage(window))}`} // Redirect not found to home
      // Support router
      // {
      //   path: 'support',
      //   component: () => import('@/views/pages/support/SupportContainer.vue'),
      //   meta: {
      //     needsSupport: true,
      //   },
      //   children: [
      //     {
      //       path: 'login',
      //       name: 'SupportLogin',
      //       component: () => import('@/views/pages/support/SupportLogin.vue'),
      //       meta: {
      //         needsLoggedIn: false,
      //       },
      //     },
      //     {
      //       path: 'usermap/set',
      //       name: 'SetUserMap',
      //       component: () => import('@/views/pages/support/SetUserMap.vue')
      //     },
      //   ]
      // },
    ]
  },
  // Redirect path add lang
  { path: "*", redirect: to => `${selectLocale(getBrowserLanguage(window))}${to.path}${to.query}`}
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  // use the language from the routing param or default language
  let language = to.params.lang;
  if (language && !(<any>Object).keys(Locale).includes(language.toUpperCase())) {
    try {
      language = selectLocale(getBrowserLanguage(window))
      const path = `${language}${to.path}`
      return next({path: path, query: to.query}); 
    } catch (e) {
      // Redirect home if path not found
      return next({path: '/'})
    }
  }

  // set the current language for vuex-i18n. note that translation data
  // for the language might need to be loaded first
  i18n.locale = selectLocale(language)
  Cookies.set('lang', language)
  next();
});

export default router